import { useMisCargos } from '@/features/pagos/api';
import { MisCargosList } from '@/features/pagos/mis-cargos-list';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Skeleton } from '@/components/ui/skeleton';

export function MisCargosRoute() {
  const { data, isLoading } = useMisCargos();

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Mi cuenta"
        title="Mis cargos pendientes"
        subtitle="Estado de cuenta de tus unidades y accesos rapidos para pagar."
        ruleSpacing="mb-8"
      />

      {isLoading || !data ? (
        <div className="space-y-4">
          <Skeleton className="h-40" />
          <Skeleton className="h-24" />
          <Skeleton className="h-24" />
        </div>
      ) : (
        <MisCargosList cargos={data.items} />
      )}
    </PageContainer>
  );
}
